import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./FooterPage.css";

const FooterPage = () => {
  return (
    <footer className="container-fluid zuppa_ajeet_footer_wrapper py-5">
      <div className="container">
        <div className="row align-items-center text-center text-lg-start">
          
          {/* ===== Logo Section ===== */}
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div className="zuppa_ajeet_footer_logo_wrapper">
              <img
                src="https://res.cloudinary.com/dmv2tjzo7/image/upload/v1735795527/zkvojccmuawxgh9eetf4.png"
                alt="Zuppa Logo"
                className="zuppa_ajeet_footer_logo"
              />
              <h5 className="zuppa_ajeet_footer_title mt-3">
                Zuppa Geo Navigation
              </h5>
            </div>
          </div>

          {/* ===== Address & Contact ===== */}
          <div className="col-lg-4 col-md-12 mb-4 mb-lg-0">
            <div className="zuppa_ajeet_footer_contact_box">
              <p className="zuppa_ajeet_footer_text">
                📍 <strong>Address:</strong> PolyHose Tower No:86, West Wing, 4th Floor, Anna Salai, Guindy, Chennai-600032
              </p>
              <p className="zuppa_ajeet_footer_text">
                📞 <strong>Sales Support:</strong> 9952081655
              </p>
              <p className="zuppa_ajeet_footer_text">
                ✉️ <strong>Sales Email:</strong> askme@zuppa.io
              </p>
              <p className="zuppa_ajeet_footer_text">
                💬 <strong>Customer Support:</strong> support@zuppa.io
              </p>
            </div>
          </div>

          {/* ===== Map Section ===== */}
          <div className="col-lg-4 col-md-12">
            <div className="zuppa_ajeet_footer_map_wrapper">
              <iframe
                src="https://www.google.com/maps?q=PolyHose%20Tower%20No:86,%20West%20Wing,%204th%20Floor,%20Anna%20Salai,%20Guindy%20Chennai-600032&output=embed"
                title="Zuppa Location"
                className="zuppa_ajeet_footer_map"
                allowFullScreen
                loading="lazy"
              ></iframe>
            </div>
          </div>

        </div>

        <div className="zuppa_ajeet_footer_bottom mt-5 text-center">
          <p className="m-0">
            © 2024 Zuppa Geo Navigation | All Rights Reserved 
          </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterPage;
